import { Injectable, inject } from "@angular/core";
import { map, Observable } from "rxjs";
import { ComparatorOperators, ConformanceToKiRsStandardField, ConformanceToKiRsStandardQueryComplexInput, ConformanceToKiRsStandardRowInput, ConformanceToKiRsStandardSimpleQueryInput, CreateOrUpdateManageKirsGQL, CreateOrUpdateManageKirsMutation, DeleteKirsGQL, DeleteKirsMutation, GetManageKirsGQL, GetManageKirsQuery, OperatorInput, PagingInput } from "../../../graphql/generated";

@Injectable({
    providedIn: 'root'
})
export class ManageKirsService {
    private readonly GetManageKirsGQL: GetManageKirsGQL = inject(GetManageKirsGQL);
    private readonly CreateOrUpdateManageKirsGQL: CreateOrUpdateManageKirsGQL = inject(CreateOrUpdateManageKirsGQL);
    private readonly DeleteKirsGQL: DeleteKirsGQL = inject(DeleteKirsGQL);

    getKirs(campaignId: string, parameters: any): Observable<GetManageKirsQuery['getConformanceToKIRsStandard']> {
        const params = convertParameters(parameters)
        return this.GetManageKirsGQL.fetch({ campaignId, page: params.page, query: params.query }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.getConformanceToKIRsStandard))
    }

    createOrUpdateKirs(campaignId: string, input: ConformanceToKiRsStandardRowInput): Observable<CreateOrUpdateManageKirsMutation['createOrUpdateConformanceToKIRsStandard']> {
        return this.CreateOrUpdateManageKirsGQL.mutate({ campaignId, input }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.createOrUpdateConformanceToKIRsStandard))
    }

    deleteKirs(campaignId: string, id: string): Observable<DeleteKirsMutation['deleteConformanceToKIRsStandard']> {
        return this.DeleteKirsGQL.mutate({ campaignId, id }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.deleteConformanceToKIRsStandard))
    }
}

export function convertParameters(parameters: any): { query: ConformanceToKiRsStandardQueryComplexInput, page: PagingInput } {
    const query: ConformanceToKiRsStandardSimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_ICS[field as keyof typeof ENUM_ICS])?.forEach(key => {

                        query.push({
                            field: key as ConformanceToKiRsStandardField,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: values
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.And
                }
            ]
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 1000000
        }
    }
}

export const ENUM_ICS = {
    order: [ConformanceToKiRsStandardField.Order],
    title: [ConformanceToKiRsStandardField.Title],
    kir: [ConformanceToKiRsStandardField.Kir],
    auditPolicyParagraph: [ConformanceToKiRsStandardField.AuditPolicyParagraph]
}